import React from 'react';
import { Box, Typography } from '@mui/material';

const Loader = ({
  loading,
  error = false,
  message = 'Loading...',
  errorMessage = 'Something isn’t quite right. Please try again.',
  onRetry
}) => {
  if (!loading && !error) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        backgroundColor: 'rgba(255,255,255,0.7)',
        zIndex: 2147483647
      }}>
      {/* 🔴 ERROR STATE */}
      {error ? (
        <>
          {/* Custom Sad Face */}
          <Box
            sx={{
              width: 80,
              height: 80,
              mb: 2,
              animation: 'sadBounce 1.5s infinite ease-in-out'
            }}>
            <svg viewBox="0 0 100 100" width="100%" height="100%">
              {/* Face */}
              <circle cx="50" cy="50" r="45" stroke="#CB6423" strokeWidth="4" fill="none" />

              {/* Eyes */}
              <circle cx="35" cy="40" r="5" fill="#CB6423" />
              <circle cx="65" cy="40" r="5" fill="#CB6423" />

              {/* Sad mouth */}
              <path
                d="M30 65 Q50 50 70 65"
                stroke="#CB6423"
                strokeWidth="4"
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </Box>

          {/* Error Message */}
          <Typography
            sx={{
              color: '#CB6423',
              fontWeight: 500,
              textAlign: 'center',
              maxWidth: 260
            }}>
            {errorMessage}
          </Typography>

          {/* Retry Button (optional) */}
          {onRetry && (
            <Box
              onClick={onRetry}
              sx={{
                mt: 2,
                px: 2,
                py: 1,
                border: '1px solid #CB6423',
                color: '#CB6423',
                cursor: 'pointer',
                fontSize: '14px',
                '&:hover': {
                  backgroundColor: 'rgba(203,100,35,0.08)'
                }
              }}>
              Try again
            </Box>
          )}
        </>
      ) : (
        <>
          {/* 🟠 LOADING STATE */}
          <Box sx={{ display: 'flex', gap: '6px', mb: 2 }}>
            {[...Array(5)].map((_, i) => (
              <Box
                key={i}
                sx={{
                  width: '6px',
                  height: '30px',
                  backgroundColor: '#CB6423',
                  animation: 'wave 1.2s infinite ease-in-out',
                  animationDelay: `${i * 0.1}s`
                }}
              />
            ))}
          </Box>

          {/* Loading Message */}
          <Typography
            sx={{
              color: '#CB6423',
              fontWeight: 500,
              letterSpacing: '0.5px'
            }}>
            {message}
          </Typography>
        </>
      )}

      {/* Animations */}
      <style>
        {`
          @keyframes wave {
            0%, 40%, 100% {
              transform: scaleY(0.4);
              opacity: 0.6;
            }
            20% {
              transform: scaleY(1);
              opacity: 1;
            }
          }

          @keyframes sadBounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(4px); }
          }
        `}
      </style>
    </Box>
  );
};

export default Loader;
